// Route parameters for subject routes
export interface SubjectRouteParams extends Record<string, string | undefined> {
  tenantId: string;
  domainId: string;
  subjectId: string;
}

// User roles specific to subject context
export enum SubjectUserRole {
  PROFESSOR = 'PROFESSOR',
  COURSE_REPRESENTATIVE = 'COURSE_REPRESENTATIVE',
}

// Table data interfaces for DataManagement components
export interface SubjectUserTableData {
  id: string;
  email: string;
  name?: string;
  role: string;
  assignedAt: string;
  assignedBy: string;
  userRoleId: string;
  userId: string;
  tenantId: string;
  domainId: string;
  subjectId: string;
  expiresAt?: string;
  isExpired: boolean;
  status: 'active' | 'invited' | 'inactive';
}

// Form data interfaces for dialog components
export interface SubjectUserFormData {
  email: string;
  name?: string;
  role: SubjectUserRole;
}

// Remove operations interfaces
export interface RemoveSubjectUserParams {
  userId: string;
  tenantId: string;
  userRoleId: string;
  userName: string;
  role: string;
}
